export default __webpack_public_path__ + "static/media/Avenir-Roman.69c16723.ttf";